import React from 'react';
import { Col, Row } from 'reactstrap';
import WalletWidget from './WalletWidget';

const WalletWrapper = ({ userWalletInfo, hook }) => {
    return (
        <Col xs={12}>
            <Row>
                <Col xxl='3' xl='4'>
                    <WalletWidget type="savings" balance={userWalletInfo.savings} hook={hook} />
                </Col>
                <Col xxl='3' xl='4'>
                    <WalletWidget type="terms" balance={userWalletInfo.terms} hook={hook} />
                </Col>
                <Col xxl='3' xl='4'>
                    <WalletWidget type="interest" balance={userWalletInfo.interest} hook={hook} />
                </Col>
            </Row>
        </Col>
    );
};

export default WalletWrapper;